import { render } from "./FeedbackDialog.vue?vue&type=template&id=02368ed6&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=02368ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02368ed6"]])

export default __exports__